<div class="search-input-area">
  <div class="container">
    <div class="search-input-inner">
      <div class="input-div">
        <input
          class="search-input autocomplete"
          type="text"
          disabled
          placeholder="Pesquise pelo nome do curso"
        />
        <button><i class="fa fa-search"></i></button>
      </div>
    </div>
  </div>
  <div id="close" class="search-close-icon">
    <i class="fa fa-times"></i>
  </div>
</div>
<div id="anywhere-home" class=""></div>
